var $5693e734f8e52053$exports = {};
const $5693e734f8e52053$var$Configuration = {
    apiUrl: "https://api.staging.hint.com",
    apiVersion: "20261014164410",
    emrNotesUrl: "https://api.one.staging.hint.com/notes",
    emrNotesVersion: undefined,
    emrNotesCsp: "https://api.one.staging.hint.com/notes/",
    emrCalendarsUrl: "https://api.one.staging.hint.com/calendars",
    emrCalendarsVersion: undefined,
    emrCalendarsCsp: "https://api.one.staging.hint.com/calendars/",
    emrMessagingUrl: "https://api.one.staging.hint.com/messaging",
    emrMessagingVersion: undefined,
    emrMessagingCsp: "https://api.one.staging.hint.com/messaging/",
    env: "staging",
    hintEnv: "staging",
    fullStoryOrgId: undefined,
    googleMapsKey: "AIzaSyCxmha8wa6V2LP3PRgLePsIABcYxZ_-oww",
    googleRecaptchaSiteKey: "6LfHJdgZAAAAAKvTxun6iCdua-WVH0_zLqdjRh8G",
    intercomAppId: undefined,
    newRelicAccountId: "1295351",
    newRelicLicenseKey: "f80caba954",
    newRelicApplicationId: "784038116",
    release: "ae37604e403d21ce367f3b04e80b018cecd407f9",
    sentryOrganizationId: "o4505133335904256",
    sentryProjectId: "4505286157729792",
    sentryKey: "558356d795f64c16a85cce356d98018c",
    sentryEnvironment: "staging",
    sentryReleaseVersion: "ae37604e403d21ce367f3b04e80b018cecd407f9",
    stripePublishableKey: "pk_test_Y7byiIyWmjqy4Xy7fjArJdPl",
    statuspageEmbedCode: undefined,
    emrChatAttachmentCsp: "https://*.s3.us-east-1.amazonaws.com",
    enableMeticulous: false
};
$5693e734f8e52053$exports = $5693e734f8e52053$var$Configuration;


window.CONFIGURATION = $5693e734f8e52053$exports;


//# sourceMappingURL=member-portal-elm.a0af1ca0.js.map
